import styled from 'styled-components';

export const Headline1 = styled.h1`
    font-family: ${props => props.theme.regularFont};
    font-weight: 600;
    font-size: 52px;
    line-height: 57.2px;
    text-align: center;
    background: linear-gradient(94.67deg, #C65DC6 10%, #E180F7 26.88%, #7F58B7 52.78%, #5DBAF2 77.92%, #F7B292 102.88%);
    background-clip: text;
    text-shadow: none;
    white-space: pre-wrap;
    -webkit-text-fill-color: transparent;
`;

export const DecoratedH3 = styled.h3`
    font-family: ${props => props.theme.regularFont};
    font-size: ${props => props.fontSize || "62px"};
    font-weight: 600;
    line-height: 68.2px;
    background: linear-gradient(89.09deg, #C65DC6 1.4%, #E180F7 19.81%, #5DBAF2 102.73%);
    background-clip: text;
    text-shadow: none;
    -webkit-text-fill-color: transparent;
`;

export const Headline2 = styled.h2`
    font-family: ${props => props.theme.regularFont};
    font-weight: 400;
    line-height: 36px;
    text-align: center;
    font-size: 24px;
    text-align: center;
    color: ${props => props.theme.textColor};
    margin: 32px 0;
    padding: 0 5px;
    max-width: 500px;
`;

export const Headline3 = styled.h3`
    font-family: ${props => props.theme.regularFont};
    font-size: 44px;
    font-weight: 600;
    line-height: 44px;
    color: ${props => props.theme.textColor};
    margin: ${props => props.$margin};
`;

export const InnerH3 = styled.h3`
    font-family: ${props => props.theme.regularFont};
    font-size: 36px;
    font-weight: 600;
    line-height: 36.16px;
    text-align: center;
    color: ${props => props.theme.textColor};
    margin: ${props => props.$margin};
`;

export const Headline4 = styled.h4`
    font-family: ${props => props.theme.regularFont};
    font-size: 32px;
    font-weight: 600;
    line-height: 43px;
    color: ${props => props.colormode === "color" ? "#E180F7" : "white"};
    margin: ${props => props.$margin};
`;

export const Headline5 = styled.h5`
    font-family: ${props => props.theme.regularFont};
    font-size: 24px;
    font-weight: 500;
    line-height: 31.2px;
    color: ${props => props.theme.textColor};
    text-align: center;
`;

// Restrained display headline: mostly white type. Wrap a single word in
// <GradientWord> to apply the brand gradient to just that word.
export const DisplayH1 = styled.h1`
    font-family: ${props => props.theme.regularFont};
    font-weight: 600;
    font-size: 48px;
    line-height: 1.05;
    text-align: center;
    color: ${props => props.theme.textColor};
    white-space: pre-wrap;
    margin: 0;

    @media screen and (min-width: 800px) {
        font-size: 64px;
    }
`;

export const GradientWord = styled.span`
    background: ${props => props.theme.brandGradient};
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: none;
`;

// Small uppercase label that sits above a headline.
export const Eyebrow = styled.span`
    font-family: ${props => props.theme.regularFont};
    font-size: 13px;
    font-weight: 500;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: ${props => props.theme.accent};
    display: inline-block;
`;

// Section heading used across the restrained sections.
export const SectionH2 = styled.h2`
    font-family: ${props => props.theme.regularFont};
    font-weight: 600;
    font-size: 36px;
    line-height: 1.1;
    text-align: ${props => props.$align || "center"};
    color: ${props => props.theme.textColor};
    margin: 0;

    @media screen and (min-width: 800px) {
        font-size: 44px;
    }
`;